module.exports = __webpack_public_path__ + "static/media/Logo__WolframAlpha.8be56568.svg";